import { createSelector } from 'reselect';
import { RouteName, FeatureFlag } from '@mews-commander/enums';
import { getProp, getStringProp } from '@mews/fp';
import { ResolveRoute } from '@mews/routing';
import { FeatureFlagService } from '@mews/framework';

const getResolveRoutePropsForMerge = createSelector(
    getProp<ResolveRoute>()('resolveRoute'),
    getStringProp('id'),
    getStringProp('otherAccountId'),
    getProp<FeatureFlagService>()('featureFlagService'),
    (resolveRoute, id, otherAccountId, featureFlagService) => ({ resolveRoute, id, otherAccountId, featureFlagService })
);
export const getMergeCompaniesUrl = createSelector(
    getResolveRoutePropsForMerge,
    ({ resolveRoute, id, otherAccountId: otherCompanyId }) =>
        resolveRoute(RouteName.CompanyDisplayMerge, { id, query: { otherCompanyId } })
);

export const getMergeCustomersUrl = createSelector(
    getResolveRoutePropsForMerge,
    ({ resolveRoute, id, otherAccountId: otherCustomerId, featureFlagService }) => {
        if (featureFlagService.hasFlag(FeatureFlag.matchAndMergeDuplicateGuestProfilesEnabled)) {
            return resolveRoute(RouteName.AccountMatchAndMerge, { query: { customerId: id, otherCustomerId } });
        }
        return resolveRoute(RouteName.CustomerDisplayMerge, { id, query: { otherCustomerId } });
    }
);
